var card_default = {
  "link": "C8Btp",
  "container": "GIWVq",
  "cardLayout": "RcVcr",
  "imageEnd": "qRzO1",
  "imageStart": "Pp7nx",
  "imageTop": "BC0DF",
  "right": "W8-yf",
  "ltr": "OwotP",
  "rtl": "hWY-f",
  "imageContainer": "_9ZP56",
  "image": "yp0zU",
  "responsiveImage": "HYDTq",
  "squareImage": "DXJdT",
  "rectangleImage": "lggXx",
  "squareRatio": "M1ZH5",
  "rectangleRatio": "C0NSL",
  "imageFill": "fvCDJ",
  "imageFit": "RgCXf",
  "imageRibbon": "Yw5D4"
};
export {
  card_default as default
};
//# sourceMappingURL=card-scss.js.map
